import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useAuth } from "../hooks/context/auth"
import { hasLocalTrackedPoints } from "../hooks/queries/tracked-points"
import { useNavigate } from "react-router"

const UnsavedTrackBanner = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Show banner only when not logged in and there are local tracked points
    setVisible(!user && hasLocalTrackedPoints())
  })

  if (!visible) return null

  return (
    <Banner>
      <span>📍 You have unsaved tracked items.</span>
      <LoginLink onClick={() => navigate("/account")}>Log in to save</LoginLink>
      <Dismiss onClick={() => setVisible(false)}>✕</Dismiss>
    </Banner>
  )
}

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.9);
  border-bottom: 2px solid #f0c040;
  color: #fff;
  font-size: 14px;
`

const LoginLink = styled.button`
  background: #f0c040;
  color: #000;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;

  &:hover {
    background: #ffd060;
  }
`

const Dismiss = styled.button`
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;

  &:hover {
    color: #fff;
  }
`

export default UnsavedTrackBanner
